/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import * as React from 'react';
import { LayoutItem } from '@oneaudi/unified-web-components';
import { OpeningHours } from './OpeningHours';
import { AddressAndContact } from './AddressAndContact';
import type { VariantConfig } from './PartnerBusinessCard';
import { PartnerBusinessCardHeader } from './PartnerBusinessCardHeader';
import { PartnerContext } from '../PartnerProvider';

interface Props extends VariantConfig {
  vtpData?: {
    vtpDealerSearchURL?: string;
    vtpPbcUrl?: string;
  };
}

export const PartnerBusinessCardFullLong = (variantConfig: Props): React.ReactElement | null => {
  const { partner, hasOpeningHours } = React.useContext(PartnerContext);
  const {
    ctaBarButtonConfig = [],
    socialMedia = [],
    headline = { headlineOrder: '2', headlineTag: 'h2' },
    vtpData,
  } = variantConfig;
  const {
    displayCtaBar,
    displayOfficialName,
    displayEmail,
    displayOpeningHours,
    displayPhone,
    isGoogleMapLink,
    isLinkedToPWS,
    showMoreInfoLink,
    showImage = true,
    showServiceList,
    showSocialMediaLinks,
  } = variantConfig.contactDetails || variantConfig;

  return partner && partner.partnerId !== '' ? (
    <>
      <PartnerBusinessCardHeader
        partner={partner}
        displayOfficialName={displayOfficialName}
        isLinkedToPWS={isLinkedToPWS}
        showImage={showImage}
        showServiceList={showServiceList}
        headline={headline}
      />
      <LayoutItem>
        <AddressAndContact
          displayCtaBar={displayCtaBar}
          ctaBarButtonConfig={ctaBarButtonConfig}
          displayEmail={displayEmail}
          displayPhone={displayPhone}
          isGoogleMapLink={isGoogleMapLink}
          isLinkedToPWS={isLinkedToPWS}
          showMoreInfoLink={showMoreInfoLink}
          showImage={showImage}
          showSocialMediaLinks={showSocialMediaLinks}
          socialMedia={socialMedia}
          dsUrl={vtpData?.vtpDealerSearchURL}
          vtpUrl={vtpData?.vtpPbcUrl}
        />
      </LayoutItem>
      {displayOpeningHours && hasOpeningHours && (
        <LayoutItem margin={['var(--spacing-relative-lg)', 0, 0, 0]}>
          <OpeningHours data={partner} isNarrow />
        </LayoutItem>
      )}
    </>
  ) : null;
};
